<template>
  <div>
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado v-if="encabezado && !sending" :elementos="encabezado" :action="action" :isViewDetailsForm="isViewDetailsForm" />
      <v-card>
        <v-card-text>
          <div
            name="table"
            v-if="showAction(1) && table"
            :class="[list.length < 6 ? 'calendar' : '']"
          >
            <v-row class="pl-5 pr-5">
              <v-col
                cols="3"
                lg="3"
                md="3"
                sm="12"
                class="pt-3"
                v-if="filterModality"
              >
                <branch-offices-list
                 :model="idBranchOfficeSelected"
                  v-on:triggerChange="branchOfficeSelected"
                />
              </v-col>
              <v-col cols="3" lg="3" md="3" sm="12" v-if="filterDate">
                <vc-date-picker
                  color="green"
                  v-model="range"
                  is-range
                  :max-date="new Date()"
                >
                  <template v-slot="{ inputEvents }">
                    <v-text-field
                      v-on="inputEvents.start"
                      :value="rangeComputed"
                      :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'"
                      @click:append="clearCalendar"
                      :disabled-input="validData"
                      :label="labelDate || 'Seleccione fecha...'"
                      single-line
                      outlinedx
                      hide-details
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col lg="6" md="6" sm="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  outlinedx
                  hide-details
                ></v-text-field>
              </v-col>
              <!-- <v-col
                cols="2"
                class="d-flex justify-center mt-4"
                v-if="!hideButtonAdd"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      @click="changeAction(2)"
                      v-bind="attrs"
                      v-on="on"
                      block
                    >
                      <v-icon left>mdi-account-multiple-plus</v-icon>
                      {{ addButtonText }}
                    </v-btn>
                  </template>
                  <span>{{ addButtonText }}</span>
                </v-tooltip>
              </v-col> -->
            </v-row>

            <component
              key="table"
              :get="get"
              :deleteItem="deleteItem"
              :listAllPagination="listAllPagination"
              :list="list"
              :is="table"
              :search="search"
              :currentPage="currentPage"
              :totalCount="totalCount"
              @isViewDetails="isViewDetails"
              :exportDentalExcel="exportDentalExcel"
              :sending="sending"
              :idBranchOfficeSelected="idBranchOfficeSelected"
            />
          </div>
          <div name="form" v-if="(showAction(2) || showAction(3)) && form">
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-form @submit.prevent="undefined">
                <component
                  :is="form"
                  key="form"
                  :model="model"
                  :modelList="modelList"
                  :idMedicalPractice="idMedicalPractice"
                  @returnTable="returnTable"
                  :isViewDetailsForm="isViewDetailsForm"
                  :takePictureOdontograma="takePictureOdontograma"
                  :saveCie10Changes="saveCie10Changes"
                />
                <div class="separator20-50"></div>
                <div class="text-center justify-center">
                  <v-col class=" justify-space-around">
                    <v-menu
                      offset-x
                      bottom
                      left
                      :close-on-content-click="true"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn
                          type="button"
                          class="mr-12 mb-4"
                          :disabled="sending"
                          outlined
                          color="error"
                          depressed
                          v-bind="attrs"
                          v-on="{ ...menu }"
                          @click="confirmationReturn()"
                        >
                          <v-icon left> mdi-close </v-icon>
                          Volver
                        </v-btn>
                      </template>
                    </v-menu>
                    <v-menu
                      offset-x
                      bottom
                      rigth
                      :close-on-content-click="true"
                      rounded="lg"
                      v-if="isViewDetailsForm == false"
                    >
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn
                          type="button"
                          class="mb-4"
                          :disabled="invalid"
                          v-bind="attrs"
                          depressed
                          v-on="{ ...menu }"
                          color="primary"
                          @click="confirmationSave()"
                        >
                          {{ saveButtonText }}
                          <v-icon right>mdi-content-save</v-icon>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </div>
              </v-form>
            </validation-observer>
          </div>
        </v-card-text>
      </v-card>
      <v-dialog persistent v-model="addWithPDF">
        <component
          key="pdfModal"
          :is="pdfModal"
          :model="model"
          @returnTable="returnTable"
          :addWithPDF="addWithPDF"
          :dentaltoPDF="dentaltoPDF"
          :productsListPrescription="productsListPrescription"
        />
      </v-dialog>
      <v-dialog v-model="swalDialog" persistent></v-dialog>
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";
import BranchOfficesList from "@/components/BranchOfficesList.vue";
import moment from "moment";
import { ReportPDFRequest } from "@/core/request";

export default {
  name: "DentalView",
  components: {
    Loader,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    BranchOfficesList,
  },
  data() {
    return {
      labelDate: null,
      cols: "col-md-3 col-xl-3 col-sm-12",
      idBranchOffice: null,
      sending: false,
      dialog: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      modelList: {
        idReferenceValue: 0,
        value: "",
      },
      encabezado: null,
      table: null,
      service: null,
      form: null,
      pdfModal: null,
      cancelationDialog: null,
      search: "",
      totalCount: 0,
      currentPage: 1,
      itemsPerPage: 10,
      searchDelay: null,
      pageCount: 1,
      hideButtonAdd: false,
      filterDate: false,
      filterModality: false,
      cancelationModal: false,
      generatePDFModal: false,
      saveButtonText: "",
      addButtonText: "",
      addWithPDF: false,
      range: "",
      idBranchOfficeSelected: null,
      idMedicalPractice: "",
      isViewDetailsForm: false,
      dateFilter: "",
      dentaltoPDF: {},
      productsListPrescription: [],
      takePictureOdontograma: false,
      saveCie10Changes: false,
      isEdit: false,
      swalDialog: false,
    };
  },
  watch: {
    idBranchOfficeState() {
      this.listAllPagination();
    },
  },

  async mounted() {
    this.service = (await this.$route.meta.service()).default || null;
    this.table = (await this.$route.meta.table()).default;
    this.form = (await this.$route.meta.form()).default;
    this.pdfModal = (await this.$route.meta.pdfModal()).default;
    this.encabezado = this.$route.meta.header;
    this.hideButtonAdd = this.$route.meta.hideButtonAdd || false;
    this.filterDate = this.$route.meta.filterDate || false;
    this.filterModality = this.$route.meta.filterModality || false;
    this.cancelationModal = this.$route.meta.cancelationModal || false;
    this.generatePDFModal = this.$route.meta.generatePDFModal || false;
    this.saveButtonText = this.$route.meta.saveButtonText || "guardar";
    this.addButtonText = this.$route.meta.addButtonText || "Agregar";
    this.typeofTable = this.$route.meta.typeofTable || "";
    this.isEdit = this.$route.meta.isEdit || false;
    this.labelDate = this.$route.meta.labelDate || "Seleccione fecha";
    this.listAllPagination();
    this.validTab();
  },
  computed: {
    ...mapState(["idBranchOfficeState"]),
    rangeComputed() {
      if (
        this.range === null ||
        this.range === "" ||
        this.range === undefined
      ) {
        return "";
      }
      return `Del ${this.$utilFront.formatDate(
        this.range.start
      )} al ${this.$utilFront.formatDate(this.range.end)}`;
    },
    validData() {
      if (this.range == "" || this.range == null || this.range == undefined) {
        return false;
      }
      this.listAllPagination();
      return true;
    },
  },
  methods: {
    /**************MODAL DENTAL PDF******************* */
    ...mapActions(["validTab"]),

    // ...mapActions(["updateBranchOffice", "updateAction"]),
    confirmationReturn() {
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea regresar a la vista principal?",
        // html: "¿Desea <b>regresar</b> a la vista principal?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.swalDialog = false;
          this.changeAction(1);
        } else {
          this.swalDialog = false;
        }
      });
    },
    confirmationSave() {
      this.swalDialog = true;
      this.saveCie10Changes = true;
      this.takePictureOdontograma = true;
      this.$swal({
        toast: true,
        title: "¿Desea guardar el registro actual?",
        // html: "¿Desea <b>guardar</b> el registro actual? ",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.saveCie10Changes = false;
          this.takePictureOdontograma = false;
          this.swalDialog = false;
          this.doAction();
        } else {
          this.swalDialog = false;
          this.takePictureOdontograma = false;
        }
      });
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllPagination();
    },
    returnTable(e) {
      if (e) {
        this.addWithPDF = false;
        this.changeAction(1);
      }
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        // this.$refs.observer.reset();
        this.listAllPagination();
        this.model = {};
        this.action = action;
      } else {
        this.action = action;
      }
    },
    doAction() {
      switch (this.action) {
        case 2:
          this.add();
          break;
        case 3:
          this.update();
          break;
        default:
          break;
      }
    },
    listAllPagination() {
      this.sending = true;
      if (this.typeofTable == "consultation") {
        let params = {
          statusAppointment: 3,
          statusMedicalPractice: 6,
          statusMedicalPracticeList: [6],
          speciality: 4,
          statusAppointmentList: [7, 3],
          idBranchOffice: this.idBranchOfficeSelected != null ? this.idBranchOfficeSelected : this.$utilFront.getIdBranchOffice()
        };

        if (this.$utilFront.nonEmpty(this.range)) {
          params.startDate = this.$utilFront.startOfDay(this.range.start);
          params.finishDate = this.$utilFront.endOfDay(this.range.end);
        }

        this.service
          .listAll(params)
          .then((res) => {
            this.sending = false;
            let { data } = res.data;
            let { length } = res.data.data;
            this.list = data;
            this.totalCount = length;
            this.pageCount = Math.ceil(length / this.itemsPerPage);
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      } else if (this.typeofTable == "history") {
        let params = {
          statusAppointment: 3,
          statusMedicalPractice: 3,
          statusAppointmentList: [3],
          statusMedicalPracticeList: [3],
          speciality: 4,
          idBranchOffice: this.idBranchOfficeSelected != null ? this.idBranchOfficeSelected : this.$utilFront.getIdBranchOffice()
        };

        if (this.$utilFront.nonEmpty(this.range)) {
          params.startDate = this.$utilFront.startOfDay(this.range.start);
          params.finishDate = this.$utilFront.endOfDay(this.range.end);
        }

        this.service.listAllHistory(params).then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.sending = false;
            this.list = res.data.data.map((list) => {
              let doctorName = " ----";
              if (list.fullNameDoctor != null) {
                doctorName = list.fullNameDoctor;
              } else if (list.nameDoctorCanceled != null) {
                doctorName = list.nameDoctorCanceled;
              }
              let status = "";
              switch (list.statusMedicalPractice) {
                case 1:
                  status = "Pendiente";
                  break;
                case 2:
                  status = "Reprogramado";
                  break;
                case 3:
                  status = "Atendido";
                  break;
                case 4:
                  status = "Cancelado";
                  break;
                case 5:
                  status = "No presento";
                  break;
                case 5:
                  status = "Presente";
                  break;
                default:
                  status = "N/A";
                  break;
              }
              return {
                idMedicalPractice: list.idMedicalPractice,
                fullNamePatient: list.fullNamePatient,
                doctor: this.$utilFront.nonEmpty(doctorName, "---"),
                dateAppointment: moment(new Date(list.appointmentDate)).format(
                  "DD/MM/YYYY HH:mm"
                ),
                status: list.nameStatus,
                idPatient: list.idPatient,
                idDiagnostic: list.idDiagnostic,
                attentionDate: list.attentionDate,
                nameStatusMedical: status,
                statusMedicalPractice: list.statusMedicalPractice,
                idPrescription: list.idPrescription,
                cancellationDate:
                  list.cancellationDate != null
                    ? this.$utilFront.formatDateTime(list.cancellationDate)
                    : " ----",
                doctorCanceled: this.$utilFront.nonEmpty(
                  list.nameDoctorCanceled,
                  "---"
                ),
              };
            });
          }
        });
      }
    },
    exportDentalExcel(typeFile) {
      this.sending = true;
      let fileName = "Historial_de_consultas_dental.xlsx";
      let data = {
        statusAppointment: 3,
        statusAppointmentList: [3, 4],
        statusMedicalPractice: 3,
        statusMedicalPracticeList: [3],
        speciality: 4,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        typeFile: typeFile,
        fileName: fileName
      };

      if (this.$utilFront.nonEmpty(this.range)) {
        data.startDate = this.$utilFront.startOfDay(this.range.start);
        data.finishDate = this.$utilFront.endOfDay(this.range.end);
      }

      ReportPDFRequest.exportDentalExcel(data)
        .then((res) => {
          this.$utilFront.downloadXLSX(res.data, fileName);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    // downloadReportXLSX() {
    //   this.sending = true;
    // let data = {
    //   page: this.options.page || 1,
    //   itemsPerPage: -1,
    //   search: this.search || "",
    //   start: this.range.start || null,
    //   end: this.range.end || null,
    // };
    // if (data.start != null && data.end != null) {
    //   data.start = moment(data.start).startOf("day");
    //   data.end = moment(data.end).endOf("day");
    // }
    // data = {
    //   status: 2,
    //   idBranchOffice:
    //     this.idBranchOfficeSelected != null
    //       ? this.idBranchOfficeSelected
    //       : this.$utilFront.getIdBranchOffice(),
    //   filter: data,
    // };

    //   ReportPDFRequest.downloadReportPrescriptionsXLSX(data)
    //     .then((response) => {
    //       const url = URL.createObjectURL(
    //         new Blob([response.data], {
    //           type: "application/vnd.ms-excel",
    //         })
    //       );
    //       /* Simulo el click */
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "Reporte de dispensaciones.xlsx");
    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .finally(() => {
    //       this.sending = false;
    //     });
    // },
    addwithPDF() {
      this.takePictureOdontograma = false;
      this.sending = true;
      this.addWithPDF = true;
      this.productsListPrescription = this.model.prescriptionProducts;
      // let odontogramaImage;
      // if(this.model.odontogramImage !=null){
      //   odontogramaImage = this.model.odontogramImage
      // } else {
      //   odontogramaImage = ""
      // }
      let dentaltreatment;
      if (this.model.listDentalTreatments != null) {
        dentaltreatment = this.model.listDentalTreatments;
      } else {
        dentaltreatment = [];
      }
      if (this.model.odontogramImage == null) {
        this.takePictureOdontograma = true;
      }
      let params = {
        idMedicalPractice: this.model.idMedicalPractice,
        subsequent: this.model.subsequent,
        listProcedureApplication: dentaltreatment,
        prescriptionList: {
          prescription: {
            diagnostic: {
              textDiagnostic: this.model.content,
              diagnosticDetails: this.model.diagnosticDetail,
            },
          },
          products: this.model.prescriptionProducts,
        },
        procedureApplicationListGeneral: this.model
          .procedureApplicationListGeneral,
        odontogramImage: this.model.odontogramImage,
        diagnosticCIE10List: this.model.cie10List,
      };
      this.service
        .add(params)
        .then((response) => {
          this.sending = false;
          let { data, status } = response;
          if (status === 200) {
            this.dentaltoPDF = data.data;
            this.listAllPagination();
            this.$utilFront.notifications(
              "Se ha atendido correctamente.",
              "SUCCESS"
            );
          } else {
            data = data || "Ocurrió un error durante el registro.";
            this.$utilFront.notifications(data, "ERROR");
          }
        })
        .catch((e) => {
          this.sending = false;
          this.$utilFront.errorhttp(e);
        })
        .finally(() => {
          this.takePictureOdontograma = false;
        });
    },
    add() {
      this.takePictureOdontograma = false;
      if (this.generatePDFModal) {
        this.addwithPDF();
      } else if (!this.sending) {
        this.sending = true;
        this.service
          .add(this.model)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;
            if (status == 200) {
              this.listAllPagination();
              this.$utilFront.notifications(
                "Se ha atendido correctamente.",
                "SUCCESS"
              );
              // this.changeAction(1);
            } else {
              data = data || "Ocurrió un error durante el registro.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    updateWithPDF() {
      this.takePictureOdontograma = false;
      this.sending = true;
      this.addWithPDF = true;
      let dentaltreatment;
      if (this.model.listDentalTreatments != null) {
        dentaltreatment = this.model.listDentalTreatments;
      } else {
        dentaltreatment = [];
      }
      let params = {
        idMedicalPractice: this.model.idMedicalPractice,
        subsequent: this.model.subsequent,
        listProcedureApplication: dentaltreatment,
        prescriptionList: {
          prescription: {
            // idPrescription: idPrescription,
            diagnostic: {
              textDiagnostic: this.model.content,
              diagnosticDetails: this.model.diagnosticDetail,
            },
          },
          products: this.model.products,
        },
        procedureApplicationListGeneral: this.model
          .procedureApplicationListGeneral,
        odontogramImage: this.model.odontogramImage,
        idAppointment: this.model.idAppointment,
        diagnosticCIE10List: this.model.cie10List,
      };
      this.service
        .update(params)
        .then((response) => {
          this.sending = false;
          let { data, status } = response;
          if (status == 200) {
            // this.listAllPagination();
            this.$utilFront.notifications(
              "Se ha modificado correctamente.",
              "SUCCESS"
            );
            // this.changeAction(1);
            this.index = -1;
          } else {
            data = data || "Ocurrió un error durante la modificación.";
            this.$utilFront.notifications(data, "ERROR");
          }
        })
        .catch((e) => {
          this.sending = false;
          this.$utilFront.errorhttp(e);
        });
    },
    update() {
      if (this.generatePDFModal) {
        this.updateWithPDF();
      } else if (!this.sending) {
        this.takePictureOdontograma = false;
        this.sending = true;
        let dentaltreatment;
        if (this.model.listDentalTreatments != null) {
          dentaltreatment = this.model.listDentalTreatments;
        } else {
          dentaltreatment = [];
        }
        let params = {
          idMedicalPractice: this.model.idMedicalPractice,
          subsequent: this.model.subsequent,
          listProcedureApplication: dentaltreatment,
          prescriptionList: {
            prescription: {
              idPrescription: this.model.idPrescription,
              diagnostic: {
                textDiagnostic: this.model.content,
                diagnosticDetails: this.model.diagnosticDetail,
              },
            },
            products: this.model.products,
          },
          procedureApplicationListGeneral: this.model
            .procedureApplicationListGeneral,
          odontogramImage: this.model.odontogramImage,
          idAppointment: this.model.idAppointment,
          diagnosticCIE10List: this.model.cie10List,
        };
        this.service
          .update(params)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;
            if (status == 200) {
              this.listAllPagination();
              this.$utilFront.notifications(
                "Se ha modificado correctamente.",
                "SUCCESS"
              );
              this.changeAction(1);
              // this.index = -1;
            } else {
              data = data || "Ocurrió un error durante la modificación.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    isViewDetails(e) {
      this.isViewDetailsForm = e;
    },
    validate() {
      // this.$refs.observer.validate();
    },
    get(params, num) {
      this.model = {};
      if (!this.sending) {
        this.sending = true;
        this.idMedicalPractice = params;
        let data = {
          idMedicalPractice: params,
        };
        this.service
          .get(data)
          .then((response) => {
            let { data, code } = response.data;
            if (code == 200) {
              this.model = data.medicalInformation;
              // this.index = Number(i);
              this.changeAction(num);
              if (this.isEdit == true) {
                this.validate();
              }
            } else {
              data = data || "Ocurrió un error al obtener la información.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },

    deleteItem(params, i) {
      // console.log(params);
      if (this.cancelationModal) {
        this.listAllPagination();
      } else if (!this.sending) {
        this.sending = true;
        this.service
          .delete(params)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;
            if (status == 200) {
              this.list.splice(i, 1);
              this.totalCount--;

              if (this.totalCount >= this.itemsPerPage) {
                this.listAllPagination();
              }

              this.$utilFront.notifications(
                "Se ha eliminado correctamente.",
                "SUCCESS"
              );
            } else {
              data = data || "Ocurrió un error al eliminar la información.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    // updateStatus(params, i) {
    //   if (!this.sending) {
    //     this.sending = true;

    //     this.service
    //       .updateStatus(params)
    //       .then((response) => {
    //         this.sending = false;
    //         let { data, status } = response;
    //         if (status == 200) {
    //           this.$utilFront.notifications(
    //             "Se ha modificado correctamente.",
    //             "SUCCESS"
    //           );
    //           this.listAllPagination();
    //         } else {
    //           data = data || "Ocurrió un error durante la modificación.";
    //           this.$utilFront.notifications(data, "ERROR");
    //         }
    //       })
    //       .catch((e) => {
    //         this.sending = false;
    //         this.$utilFront.errorhttp(e);
    //       });
    //   }
    // },
    clearCalendar() {
      this.range = "";
      this.listAllPagination();
    },
  },
};
</script>
